exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.embed#form-page[data-v-7f511c2b] {\n    background: transparent;\n}\n", ""]);

// exports
